<template>
  <body class="signIn">
    <div class="text1">报名吉林一号遥感开发者培训班</div>
    <div class="white">
      <div class="text2">1 / 2</div>
      <div class="text2" style="top: 116px">请选择学习方式</div>
      <div class="online" @click="jumpSignInContent()">仅报名线上课堂</div>

      <!-- 下次报名记得把实名验证加上 -->
      <div class="online-grey" >报名长春站
        <div class="onlinesText">报名截止</div>
      </div>
      <!-- <div class="online-s"  @click="$router.push({path:'/signInContent',query:{'type':2}});refreshLocation();">报名北京行（第二期）</div> -->
      
      <div class="text3" @click="shadow = 1">
        了解学员激励政策
        <img src="~@/assets/Home/详情icon.png" alt="" class="content2Img2" />
      </div>
      <div
        class="text3"
        @click="
          $router.push('/courseDetail');
          refreshLocation();
        "
        style="top: 469px;left: 591px;width: 127px;"
      >
      了解长春站详情
        <img
          src="~@/assets/Home/详情icon.png"
          alt=""
          class="content2Img2"
          style="left: 106px"
        />
      </div>
    </div>
    <div class="shadow" v-if="shadow == 1">
      <div class="shadowWhite">
        <div class="text4">学员激励政策</div>
        <div class="text5">
          1、取得结业认证的优秀学生学员，在符合公司硬性招聘条件的情况下优先发放offer
          <br />&nbsp; &nbsp; &nbsp;或实习机会；
          <br />2、免费获得实践类课程所需资源(如高分辨样例数据)，取得结业认证的优秀学员可获
          <br />&nbsp; &nbsp;
          &nbsp;得生态开放商城付费生态会员与高分辨数据兑换券；
          <br />3、获得结业认证的学员所在组织有机会成为吉林一号生态合作伙伴；
          <br />4、获得结业认证的优秀学员有机会获得吉林一号开发者官方认证资格；
          <br />5、获得结业认证的学员可获得在线商城永久学员限定认证勋章，获评认证等级，线
          <br />&nbsp; &nbsp; &nbsp;下集训营学员可额外获得实体结业证书。
          <br /><span style="font-size: 14px; color: #c49760"
            >注：该激励政策最终解释权归长光卫星技术股份有限公司，政策可能根据实际运行情况调整</span
          >
        </div>
        <div class="shadowButton" @click="xianxiaJudge()">确定</div>
      </div>
    </div>
    <div class="shadow" v-if="shadow == 2">
      <div class="shadow2White">
        <div class="text4">集训营提示</div>
        <div class="text6">
          亲爱的用户，本次报名将同步为您开启线上课程学习权限，请确认您是否能够全程参与培训班杭州行：
          <br />&nbsp; &nbsp; &nbsp;i.
          若不能或不确定，则需完成全部线上课程方能取得结业认证，线上学习没有场地和时间限制；
          <br />&nbsp; &nbsp; &nbsp;ii.
          若确定能够全程参与培训班杭州行，可在培训结束并通过学习成果验收后获得结业认证。
          <br />&nbsp; &nbsp; &nbsp;iii.
          我们对线上学习或线下集训获得结业认证的学员给予相同的<span
            style="color: #c49760; text-decoration: underline; cursor: pointer"
            @click="shadow = 1;xianxia=true"
            >激励政策</span
          >
        </div>
        <div class="shadow2Button" v-if="waiting">我已知悉 ({{ second }}s)</div>
        <div class="shadow2Button-s" v-if="!waiting" @click="$router.push({path:'/signInContent',query:{'type':2}});refreshLocation();">我已知悉</div>
      </div>
    </div>
  </body>
</template>
<script>
import {rootUrl} from '@/globalConfig'
//   import $ from "jquery";
export default {
  name: "signIn",
  data() {
    return {
      shadow: 0,
      second: 5,
      waiting:true,
      timer:'',
      xianxia:false,
      pathUrl:'',
      signInRepeat:0,
    };
  },
  beforeRouteEnter(to, from, next) {
          next(vm=>{  
            console.log(from)
            vm.pathUrl = from.path;
          })
        },
  methods: {
    getKey() {
      return localStorage.getItem("token");
    },
    refreshLocation() {
      // location.reload();
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant",
      });
    },
    daojishi(){
        if(this.second<=0){
            this.waiting=false
            clearInterval(this.timer);
        }else{
            this.second--
        }
    },
    dajishiOn(){
        this.$nextTick(() => {
        this.timer = setInterval(this.daojishi, 1000);
    });
    },
    xianxiaJudge(){
      if(this.xianxia){
        this.shadow=2
      }else{
        this.shadow=0
      }
    },
    //带权限判断的跳转
    jumpWithPermission(type,path,fromUrl){
      //path:需要跳转到的路由；fromUrl：如果权限不满足，满足后回跳的路由
      //注意：fromUrl必须为包含本项目router中base的相对地址，如商城个人中心为：/store/UserCenter
      let loginUserId=localStorage.getItem('userId');//是否已登录
      let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
      if(type=='可游客'){
        if(fromUrl){
          window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
        }
        else {
          window.open(rootUrl+path,"_self")
        }
      }else if(type=='仅登录'){
        //已登录
        if(loginUserId){
          if(fromUrl){
            window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
          }
          else {
            window.open(rootUrl+path,"_self")
          }
        }
        //未登录
        else {
          if(fromUrl){
            window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
          }
          else {
            window.open(rootUrl+'/Login',"_self")
          }
        }
      }else if(type=='仅实名'){
        //已登录
        if(loginUserId){
          //已实名
          if(authentication=='0'){
            if(fromUrl){
              window.open(rootUrl+path+"?fromUrl="+rootUrl+fromUrl,"_self")
            }
            else {
              window.open(rootUrl+path,"_self")
            }
          }
          //未实名
          else {
            window.open(rootUrl+'/Authentication',"_self")
          }

        }
        //未登录
        else {

          if(fromUrl){
            window.open(rootUrl+'/Login'+"?fromUrl="+rootUrl+fromUrl,"_self")
          }
          else {
            window.open(rootUrl+'/Login',"_self")
          }
        }
      }
    },
     //实名权限检查与处理（培训班版）
     checkAndHandleAuthentication(){
        console.log("进入实名检查")
        let loginUserId=localStorage.getItem('userId');//是否已登录
        let authentication=localStorage.getItem('authentication');//0:已实名；1：未实名
        console.log(loginUserId,authentication)
        console.log(localStorage.getItem('preRoute'))
        if(!loginUserId){
          this.jumpWithPermission('仅登录','/Login','/learn/')
        }
        else if(authentication!='0'){
          this.jumpWithPermission('仅实名','/Authentication','/learn/')
      }
      return true;
    },
    jumpSignInContent(){
      if(this.checkAndHandleAuthentication()){
        this.$router.push({path:'/signInContent',query:{'type':1}});
        this.refreshLocation();
      }
    }
  },

  mounted() {
    // this.getLoginInfo()
  },
};
</script>
<style scoped>
.shadow {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000;
}
.shadowWhite {
  position: absolute;
  top: calc(50% - 290px);
  left: calc(50% - 400px);
  width: 800px;
  height: 580px;
  background: #ffffff;
  border-radius: 16px;
}
.text4 {
  position: absolute;
  top: 40px;
  left: calc(50% - 100px);
  width: 200px;
  height: 28px;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3a3a3a;
  line-height: 28px;
  text-align: center;
}
.text6 {
  position: absolute;
  top: 103px;
  left: calc(50% - 300px);
  width: 600px;
  height: 180px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 500;
  color: #3a3a3a;
  line-height: 30px;
}
.shadow2Button {
  position: absolute;
  top: 330px;
  left: calc(50% - 75px);
  width: 150px;
  height: 44px;
  background: #cccccc;
  border-radius: 22px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 44px;
  text-align: center;
}
.shadow2Button-s {
  position: absolute;
  top: 330px;
  left: calc(50% - 75px);
  width: 150px;
  height: 44px;
background: #C49760;
  border-radius: 22px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 44px;
  text-align: center;
  cursor: pointer;
}
.text5 {
  position: absolute;
  top: 108px;
  left: calc(50% - 300px);
  width: 600px;
  height: 324px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #3a3a3a;
  line-height: 36px;
}
.shadowButton {
  position: absolute;
  top: 496px;
  left: calc(50% - 48px);
  width: 96px;
  height: 44px;
  background: #c49760;
  border-radius: 22px;
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 500;
  color: #ffffff;
  line-height: 44px;
  text-align: center;
  cursor: pointer;
}
.shadow2White {
  position: absolute;
  top: calc(50% - 200px);
  left: calc(50% - 400px);
  width: 800px;
  height: 400px;
  background: #ffffff;
  border-radius: 16px;
}
.signIn {
  position: relative;
  width: 100%;
  height: 100%;
  background: #f5f5f6;
}
.text1 {
  position: absolute;
  top: 174px;
  left: calc(50% - 208px);
  width: 416px;
  height: 31px;
  font-size: 26px;
  font-family: Tensentype-ZhiHeiJ-W4, Tensentype-ZhiHeiJ;
  font-weight: normal;
  color: #3a3a3a;
  line-height: 31px;
  text-align: center;
}
.white {
  position: absolute;
  top: 259px;
  left: calc(50% - 640px);
  width: 1280px;
  height: 600px;
  background: #ffffff;
  box-shadow: 0px 5px 10px 0px rgba(0, 0, 0, 0.05);
  border-radius: 16px;
}
.text2 {
  position: absolute;
  top: 61px;
  left: calc(50% - 100px);
  width: 200px;
  height: 30px;
  font-size: 26px;
  font-family: Arial-BoldMT, Arial;
  font-weight: normal;
  color: #979797;
  line-height: 31px;
  text-align: center;
}
.online {
  position: absolute;
  top: 200px;
  left: 213px;
  width: 400px;
  height: 200px;
  background: #ffffff;
  box-shadow: 0px 0px 15px 4px rgba(151, 151, 151, 0.3);
  border-radius: 16px;
  font-size: 26px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #979797;
  line-height: 200px;
  text-align: center;
  cursor: pointer;
}
.online:hover {
  color: #ffffff;
  background: linear-gradient(134deg, #ffb963 0%, #c49760 100%);
}
.online-s {
  position: absolute;
  top: 200px;
  left: 667px;
  width: 400px;
  height: 200px;
  background: #fff;
  box-shadow: 0px 0px 15px 4px rgba(151, 151, 151, 0.3);
  border-radius: 16px;
  font-size: 26px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #979797;
  line-height: 200px;
  text-align: center;
  cursor: pointer;
}
.online-s:hover {
  color: #ffffff;
  background: #FFFFFF linear-gradient(134deg, #63D9FF 0%, #C352EE 100%);
  box-shadow: 0px 0px 10px 4px rgba(151,151,151,0.25);
}
.online-grey {
  position: absolute;
  top: 200px;
  left: 667px;
  width: 400px;
  height: 200px;
  background: #ccc;
  box-shadow: 0px 0px 15px 4px rgba(151, 151, 151, 0.3);
  border-radius: 16px;
  font-size: 26px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #979797;
  line-height: 200px;
  text-align: center;
  cursor: pointer;
}
.onlinesText{
  position: absolute;
  top: 125px;
  left:calc(50% - 200px);
  width: 400px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 400;
  line-height: 20px;
  text-align: center;
  cursor: pointer;
}
.onlineText{
  position: absolute;
  top: 135px;
  left: calc(50% - 150px);
  width: 300px;
height: 20px;
font-size: 14px;
font-family: PingFangSC-Regular, PingFang SC;
font-weight: 400;
color: #979797;
line-height: 20px;
}
.text3 {
  position: absolute;
  top: 509px;
  left: 578px;
  width: 150px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #c49760;
  line-height: 20px;
  /* text-shadow: 0px 0px 5px rgba(0,0,0,0.5); */
  text-align: left;
  cursor: pointer;
}
.content2Img2 {
  position: absolute;
  top: 5px;
  left: 118px;
  width: 6px;
  height: 12px;
}
</style>
